import React from "react";
import useSWR from "swr";
import api, { money, fmtDate } from "@/lib/api";

const fetcher = (u) => api.get(u).then((r) => r.data);

export default function BookingPlanCell({ participantId }) {
  const { data: plan } = useSWR(participantId ? `/bookings/${participantId}/plan` : null, fetcher);
  if (!plan) return <div className="text-xs text-slate-400 mono">…</div>;
  const pct = plan.price_final > 0 ? Math.min(100, (plan.paid_total / plan.price_final) * 100) : 0;
  const barColor = plan.balance <= 0 ? "bg-emerald-500" : plan.paid_total >= plan.deposit_amount ? "bg-[#026FCB]" : "bg-amber-500";
  return (
    <div className="min-w-[180px]" data-testid={`plan-${participantId}`}>
      <div className="flex items-center justify-between text-xs mono mb-1">
        <span className="text-slate-500">{money(plan.paid_total)} / {money(plan.price_final)}</span>
        <span className={plan.overdue ? "text-red-600 font-semibold" : "text-slate-500"}>{Math.round(pct)}%</span>
      </div>
      <div className="h-1.5 rounded-full bg-slate-100 dark:bg-[#1A2336] overflow-hidden">
        <div className={`h-full ${barColor}`} style={{ width: `${pct}%` }} />
      </div>
      {plan.next_due && (
        <div className={`text-[10px] mono mt-1 ${plan.overdue ? "text-red-600" : "text-slate-500"}`}>
          {plan.next_due.kind === "deposit"
            ? <>Depósito: {money(plan.next_due.amount)}</>
            : <>Saldo: {money(plan.next_due.amount)}{plan.next_due.date ? <> · vence {fmtDate(plan.next_due.date)}</> : null}</>}
        </div>
      )}
    </div>
  );
}
